import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpCreateFollowUp, HttpCreateFollowUpOptions} from './treatment-requests.http'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosResponse} from 'axios'
import {FollowUp} from '@/features/treatment-requests/types'

export const useCreateFollowUp = (
    options?: UseMutationOptions<AxiosResponse<FollowUp>, unknown, HttpCreateFollowUpOptions>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_FOLLOW_UP],
        mutationFn: httpCreateFollowUp
    })
}
